import { device, Platform } from '@rbx/core';
import { useEffect, useMemo, useState } from 'react';

const { getCurrentPlatform, getCurrentBrowser } = device;

export default function useDeviceInfo() {
  const [currentBrowser, setCurrentBrowser] = useState<ReturnType<typeof getCurrentBrowser>>();

  const currentPlatform = useMemo(() => getCurrentPlatform(), []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentBrowser(getCurrentBrowser());
    }
  }, []);

  const isMobileDevice = useMemo(
    () => currentPlatform === Platform.Android || currentPlatform === Platform.iOS,
    [currentPlatform],
  );

  return { isMobileDevice, currentPlatform, currentBrowser };
}
